import { Card, Grid } from '@mui/material'

import { useCallback, useEffect, useState } from 'react'
import { ContentWrapper } from '../../components/ContentWrapper'
import Helmet from '../../components/Helmet'
import HeaderContent from '../../components/Layouts/HeaderContent'
import useAxios from '../../hooks/useAxios'
import useSocket from '../../hooks/useSocket'
import { useUser } from '../../hooks/useUser'
import facebookChatSubscribe from '../../subscribers/facebook-chat.subscribe'
import { IFacebookChatRoom, IFacebookChatRoomCount } from '../../types/facebook'
import ChatPanel from './components/ChatPanel'
import ChatSidebar from './components/ChatSidebar'
import ChatWindow from './components/ChatWindow'
import { IMessageItem } from '../../resources/chats'
import { UserRole } from '../../types/user'
import { isRoleMerchant } from '../../utils/getRoleUser'

const Menus: any = []

const ChatsPage = () => {
  const [isOpenedCustomerPanel, setIsOpenedCustomerPanel] =
    useState<boolean>(false)

  const [params, setParams] = useState<Record<string, any>>({
    chatType: 'me',
  })

  const [openChat, setOpenChat] = useState<IFacebookChatRoom | null>(null)
  const [incommingMessage, setIncommingMessage] = useState<IMessageItem>()

  const [connect, setConnect] = useState<boolean>(false)
  const { merchant, user } = useUser(false)
  const socket = useSocket()

  const roles = user?.roles || []
  const isMerchant = isRoleMerchant(roles)

  const { data: chatRoomsCount, mutate: chatRoomsCountMutate } =
    useAxios<IFacebookChatRoomCount>(
      {
        url: '/facebook/pages/chatrooms/count',
        method: 'GET',
      },
      {
        revalidateOnFocus: true,
      },
    )

  const handleMutate = useCallback(() => {
    // chatRoomMutate()
    chatRoomsCountMutate()
  }, [chatRoomsCountMutate])

  useEffect(() => {
    if (socket && !connect) {
      setConnect(true)
      facebookChatSubscribe(socket, {
        merchant,
        user,
        mutate: handleMutate,
        setIncommingMessage,
      })
    }
  }, [socket])

  return (
    <ContentWrapper>
      {/* <CircularLoading isLoading={isLoading} /> */}
      <Helmet title="แชท" />
      <HeaderContent goBack title="แชท" routes={Menus} descriptions="แชท" />
      <Card>
        <Grid container minHeight={780} alignItems={'stretch'}>
          {isMerchant && (
            <Grid
              item
              lg={isOpenedCustomerPanel ? 1 : 2}
              xs={12}
              sx={{
                borderRight: 1,
                borderColor: 'grey.200',
              }}
            >
              <ChatSidebar
                setParams={setParams}
                isOpenedCustomerPanel={isOpenedCustomerPanel}
                chatRoomsCount={chatRoomsCount}
              />
            </Grid>
          )}
          <Grid
            item
            lg={3}
            xs={12}
            sx={{
              borderRight: 1,
              borderColor: 'grey.200',
            }}
          >
            <ChatPanel tabParams={params} setOpenChat={setOpenChat} />
          </Grid>
          {openChat && (
            <>
              <Grid
                item
                lg={
                  isOpenedCustomerPanel
                    ? isMerchant
                      ? 8
                      : 9
                    : isMerchant
                      ? 7
                      : 9
                }
                xs={12}
                sx={{
                  borderRight: 1,
                  borderColor: 'grey.200',
                }}
              >
                <ChatWindow
                  handleMutate={handleMutate}
                  incommingMessage={incommingMessage}
                  isOpenedCustomerPanel={isOpenedCustomerPanel}
                  setIsOpenedCustomerPanel={setIsOpenedCustomerPanel}
                  chatRoom={openChat}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Card>
    </ContentWrapper>
  )
}
export default ChatsPage
